//满赠逻辑



//满赠逻辑





window.runCartFlow = runCartFlow;

var productIdNumMapLines = ''

//满赠逻辑

async function runCartFlow() {
console.log('打印满赠');



  const cartGid = "gid://shopify/Cart/"+ await getCartIdFromCookie();
console.log('cartGid', cartGid);

  const cartData = await getCartLines(cartGid);  //当前购物车数据
  console.log('当前购物车数据',cartData);
  

  const productCollectionsMap = await getLinecollectionIds(cartData); //当前购物车产品的类目

  const rulesJson = await getConfig(); //规则配置

  const cartSubTotalCost = cartData.data.cart.cost.subtotalAmount; //subtotal

  const lines = cartData.data.cart.lines.edges;

  console.log("lines:", lines);

  var addGift = [];

  var delGift = [];

  //console.log("购物车总价:", cartSubTotalCost.amount);

  //console.log('当前购物车内的所有产品的集合id',collectionIds)



  // 判断所有行是否都是赠品

  const onlyGift = lines.length > 0 && lines.every(edge => {
    console.log('edge1:', edge);
    
    const attrs = edge.node.attributes || [];

    return attrs.some(attr => attr.key === "is_gift" && attr.value === "true");

  });



  if (onlyGift) {

    //确定所有行都为赠品  直接清空所有赠品

    const giftLineIds = lines.map(edge => edge.node.id);

    // 用 cartLinesRemove mutation 批量移除所有赠品

    // 伪代码，实际调用你的 removeGiftFromCart 方法

    item = await removeGiftFromCart(giftLineIds, cartGid);
    console.log('走清空赠品',item)
    console.log('74添加下面的productIdNumMap',productIdNumMap);
    if(item){

       if(item){
          // 先安全地取出 edges 数组
        const edges = item?.data?.cartLinesRemove?.cart?.lines?.edges || [];
  


        renderCartItemsFromCartJS(edges)
       }
    }
    return ;
  }



  //验证是否满足赠送条件
    // const targetCollectionId = "161424244870";
    const productIdNumMap = {}; 

  for (const key in rulesJson) {

    const variantGid = "gid://shopify/ProductVariant/"+key;

    //2. 查找赠品行

    let lineId = null;

    for (const edge of lines) {

      //判断哪个是赠品

      if(variantGid == edge.node.merchandise.id)  {

        lineId = edge.node.id; //作为取消赠品的条件查出来lineId

        break;

      }

    }



    const rule = rulesJson[key];

    const ruleArray = Array.isArray(rule) ? rule : [rule];

    //规则判断

    let categoryOk = false;  // 只要有一个满足即可

    let timeOk = false;

    let subtotalOk = true;

    let ruleMatched = false;  // 👈 新增标记，确保只送一次

    //规则判断

    for (const r of ruleArray) {

      
      // 当前本地时间
        const nowLocal = new Date();

        // 转成美国东部时间字符串（可读）
        const estStr = nowLocal.toLocaleString('en-US', { timeZone: 'America/New_York' });

        // 如果需要 Date 对象，可以用字符串再转换
        const now = new Date(estStr);

        console.log("美国东部时间（Date 对象）:", now);
        console.log("美国东部时间（可读字符串）:", estStr);

      
      // const now = new Date();
      
      // ===== 时间判断 =====

      const startTime = r.statTime || (r.time && r.time.statTime);

      const endTime   = r.endTime   || (r.time && r.time.endTime);



      if (!startTime && !endTime) {

        timeOk = true;

      } else {

        const start = startTime ? new Date(startTime) : null;

        const end   = endTime ? new Date(endTime) : null;

        if ((!start || now >= start) && (!end || now < end)) {

          timeOk = true;

          console.log(`规则 ${key} 时间符合`, start,end);
          

        }else{

          console.log(`规则 ${key} 时间不符合`, r);

          continue;

        }

      }



      // ===== 类别判断 =====

      console.log('productCollectionsMap4',productCollectionsMap)
      const targetCollectionId = "161424244870";
      // const productIdNumMap = {}; 
    
      Object.keys(productCollectionsMap).forEach(productGid => {
        const collections = productCollectionsMap[productGid];
        console.log('productGid:', productGid);
        console.log('collections:', collections);

        if (collections.includes(targetCollectionId)) {
          // 提取纯数字 productId
          const productIdNum = productGid.split('/').pop();
          // 推入对象里，值可以存 true 或 productGid 对象，看你需求
          productIdNumMap[productIdNum] = true; 
        }


      });
      // console.log('productIdNumMap',productIdNumMap);
      
      const categorys = r.category || {};

      const include = Array.isArray(categorys.in) ? categorys.in.map(String) : [];

      const exclude = Array.isArray(categorys.not_in) ? categorys.not_in.map(String) : [];



      // 遍历每个商品及其所属集合

      for (const [productId, collections] of Object.entries(productCollectionsMap)) {

        console.log('collections',collections)

        // 如果命中 exclude，就直接跳过这个商品

        if (exclude.length > 0 && exclude.some(id => collections.includes(id))) {

          continue;

        }



        // 如果设置了 include，则必须命中一个 include

        if (include.length > 0) {

          if (include.some(id => collections.includes(id))) {

            categoryOk = true; // ✅ 找到符合条件的商品

            console.log(`规则 ${key} 类别符合1`, r);

            break;

          }

        } else {

          // 没有 include，且没触发 exclude，那就算符合

          console.log(`规则 ${key} 类别符合2`, r);

          categoryOk = true;

          break;

        }

      }



      // 如果没有任何产品符合条件

      if (!categoryOk) {

        console.log(`规则 ${key} 类别不符合`, r);

        continue;

      }



      // ===== 小计判断 =====

      if (r.sub_total) {

        const operator = r.sub_total.operator;

        const value = Number(r.sub_total.value);

        const cartSubtotal = Number(cartSubTotalCost.amount); // 转数字



        switch (operator) {

          case "gt":

            subtotalOk = cartSubtotal > value;

            break;

          case "lt":

            subtotalOk = cartSubtotal < value;

            break;

          case "ge":

            subtotalOk = cartSubtotal >= value;

            break;

          case "le":

            subtotalOk = cartSubtotal <= value;

            break;

          case "eq":

            subtotalOk = cartSubtotal === value;

            break;

          case "neq":

            subtotalOk = cartSubtotal !== value;

            break;

          default:

            subtotalOk = true; // 没定义就放过

        }

      }

      if (!subtotalOk) {

        console.log(`规则 ${key} 小计不符合`,r);

        continue;

      }



      // ===== 到这里说明所有条件都通过 =====

      //赠送礼品  如果有赠品  就不送了



      if (!subtotalOk) continue;

      // ✅ 到这里说明满足当前 r，标记并跳出整个循环

      ruleMatched = true;

      break;

    }



    // ===== 根据最终匹配结果处理赠品 =====

    if (ruleMatched && !lineId) {

      // 没有赠品 -> 添加

      addGift.push(variantGid);

      console.log(`添加赠品：${variantGid}`);

    } else {

      // 已有赠品

      if(!ruleMatched && lineId){

        delGift.push(lineId)

        console.log(`删除无效赠品${variantGid}`,key);

      }

      console.log(`已有赠品${variantGid}`);

    }

  }

// best sell 产品id存放对象
console.log('productIdNumMap',productIdNumMap);

  console.log('添加变体数组',addGift)

  console.log('删除行数组',delGift)



  var item = [];



  //批量增加商品
  console.log('406添加下面的productIdNumMap',productIdNumMap);
  if(addGift.length > 0){
    console.log('进添加');
    
    item =  await addGiftToCart(cartGid, addGift)

    console.log('走添加',item)
    if(item){
      console.log('413添加下面的productIdNumMap',productIdNumMap);
      productIdNumMapLines = productIdNumMap;
            // 先安全地取出 edges 数组
        const edges = item?.data?.cartLinesAdd?.cart?.lines?.edges || [];
        renderCartItemsFromCartJS(edges)
    }
  }



  //批量删除商品
  console.log('422添加下面的productIdNumMap',productIdNumMap);

  if(delGift.length >  0){

    item = await removeGiftFromCart(delGift, cartGid);
    console.log('走删除',item)

    if(item){

       if(item){
        console.log('423添加下面的productIdNumMap',productIdNumMap);
        productIdNumMapLines = productIdNumMap;
          // 先安全地取出 edges 数组
        const edges = item?.data?.cartLinesRemove?.cart?.lines?.edges || [];
        renderCartItemsFromCartJS(edges)
       }
    }

  }

  
//441
}



async function getLinecollectionIds(cartData)

{

// 假设 result 是你的 GraphQL 查询返回的 cart 对象

  const productIds = [];

  cartData.data.cart.lines.edges.forEach(edge => {

    const attrs = edge.node.attributes || [];

    const isGift = attrs.some(attr => attr.key === "is_gift" && attr.value === "true");

    if (isGift) {

      // 是赠品，跳过 

      return;

    }

    const productId = edge.node.merchandise.product.id;

    if (!productIds.includes(productId)) {

      productIds.push(productId);

    }

  });



  console.log(productIds)

  let query = 'query {';

  productIds.forEach((id, idx) => {

    query += `

          product${idx}: product(id: "${id}") {

            id

            collections(first: 10) {

              nodes {

                id

                title

              }

            }

          }

        `;

  });

  query += '}';





  const collectionsResult = await graphqlStar(query); // 一定要加 await

  console.log('collectionsResult', collectionsResult);



  if (!collectionsResult || !collectionsResult.data) {

    console.error('GraphQL 查询失败或无数据', collectionsResult);

    return;

  }



  // 存放结果：以 product.id 为 key

  const productCollectionsMap = {};



  Object.values(collectionsResult.data).forEach(product => {

    const productId = product.id; // product 的全局 gid

    if (!productCollectionsMap[productId]) {

      productCollectionsMap[productId] = [];

    }



    product.collections.nodes.forEach(collection => {

      // 只要纯数字 ID

      const id = collection.id.split('/').pop();

      if (!productCollectionsMap[productId].includes(id)) {

        productCollectionsMap[productId].push(id);

      }

    });

  });

  console.log('productCollectionsMap',productCollectionsMap)

  return productCollectionsMap;

}





//公用请求



async function graphqlStar(query) {



  const response = await fetch('https://klaiyi.myshopify.com/api/2024-04/graphql.json', {



    method: 'POST',



    headers: {



      'Content-Type': 'application/json',



      'X-Shopify-Storefront-Access-Token': '825b0364aba235b72a962b67629df51d',



    },



    body: JSON.stringify({



      query



    }),



  });







  return await response.json();



}







//获取满赠配置



async function getConfig() {



  const match = {};



  //gt 👉 greater than (>) 大于



  //lt 👉 less than (<) 小于



  //ge 👉 greater or equal (>=) 大于等于



  //le 👉 less or equal (<=) 小于等于



  //eq 👉 equal (=) 等于



  //neq 👉 not equal (<>) 不等于



  return {



    "41183564005510": {



      "time": {

        "statTime": null,

        "endTime": null

      },



      "category": {



        "in": [],



        "not_in": [77830455341]



      },



      "sub_total": {



        "operator": "ge",



        "value": "0"



      }



    },



    "39981090340998": [{



      "time": {



        "statTime": "2025-09-08 00:00:00",



        "endTime": "2025-09-10 23:59:59"



      },



      "sub_total": {



        "operator": "ge",



        "value": "169"



      },



      "category": {



        "in": [],



        "not_in": [77830455341, 265045540998, 269495959686, 273618403462, 263551320198]



      }



    },



      {



        "time": {

          "statTime": "2025-09-11 00:00:00",

          "endTime": "2025-09-18 00:00:00",

        },

        "sub_total": {



          "operator": "ge",



          "value": "199"



        },



        "category_ids": {



          "in": [],



          "not_in": [77830455341, 265045540998, 269495959686, 273618403462, 263551320198]



        }



      },



      {

        "time": {

          "statTime": "2025-09-19 00:00:00",

          "endTime": "2025-09-19 00:00:00",

        },

        "sub_total": {



          "operator": "ge",



          "value": "169"



        },



        "category_ids": {



          "in": [],



          "not_in": [77830455341, 265045540998, 269495959686, 273618403462, 263551320198]



        }



      }



    ]



  };



}







//获取购物车ID



function getCartIdFromCookie() {



  return fetch('/cart.js')



    .then(res => res.json())



    .then(cart => {



      console.log('返回内容',cart);


      return cart.token;



      // 这是 Ajax Cart 的 token，不是 Storefront API 的 cartId



    });



}



// 根据 /cart.js 的 items 渲染页面


// console.log('938添加下面的productIdNumMap',productIdNumMap);
function renderCartItemsFromCartJS(edges) {
  
 // 打印每个 edge 的内容
 // 转换成和 /cart.js 类似的结构
 const items = edges.map(edge => {
 const node = edge.node;
 const amountPerQuantity = edge.node.cost.amountPerQuantity.amount;
 const subtotalAmount = edge.node.cost.subtotalAmount.amount;
 const totalAmount = edge.node.cost.totalAmount.amount;
//  元字段数据
// longqi 
const longqiDiscount = edge.node.merchandise.product.coupon_rule?.value || null
// const longqiDiscount = JSON.parse(edge.node.merchandise.product.coupon_rule.value).discount;
console.log('longqiDiscount',longqiDiscount);
const parsed = (longqiDiscount && longqiDiscount !== "null") 
  ? JSON.parse(longqiDiscount) 
  : null;
const { discount:longqiCouponRuleDiscount, discount_type:longqiCouponRuleDiscountType } = parsed || {};
console.log("longqiDiscount-discount:", longqiCouponRuleDiscount);
console.log("longqiDiscount-discountType:", longqiCouponRuleDiscountType);
// custom 
// edge.node.merchandise.product.gift
const customGiftValue = edge.node.merchandise.product.gift?.value || null
console.log('customShipping',customGiftValue);
const customShippingValue = edge.node.merchandise.product.shipping?.value || null
console.log('customShipping',customShippingValue);
const customCartProductGiftValue = edge.node.merchandise.product.cart_product_gift?.value || null
console.log('cartProductGift',customCartProductGiftValue);


 const merchandise = node.merchandise;
 const product = merchandise.product;
 const attributes = node.attributes;
 const attributesgift = attributes[0]
const attributesgiftkey =  attributes[0]?.key || null
const attributesgiftvalue = attributes[0]?.value || null
 console.log(attributesgift);
 
 console.log('attributes::',attributes);
 const discountProductTotalAmount = totalAmount / node.quantity;
 const discountAllTotalAmount = (amountPerQuantity - discountProductTotalAmount) * node.quantity;
 return {
  amountPerQuantity:amountPerQuantity,
  customGiftValue:customGiftValue,
  customShippingValue:customShippingValue,
  customCartProductGiftValue:customCartProductGiftValue,
  longqiCouponRuleDiscountType:longqiCouponRuleDiscountType,
  longqiCouponRuleDiscount:longqiCouponRuleDiscount,
   attributesgiftvalue:attributesgiftvalue,
   variant_id: merchandise.id, // 这里返回的是 GID，可根据需求解析或直接用
   product_id: product.id,
   sku: merchandise.sku,
   image: merchandise.image?.url || product.featuredImage?.url || '',
   url: `/products/${product.handle}`, // Shopify产品详情页
   product_title: product.title,
   title: merchandise.title, // 变体标题
   variant_title: merchandise.title,
   quantity: node.quantity,
   //计算折扣后的价格
  //  折扣码之后 产品单价
   discount_product_totalAmount : discountProductTotalAmount,
  // 当前产品的 (现价 - 一口价)x 数量 = 折扣总金额 
    discount_all_totalAmount:discountAllTotalAmount,

   // GraphQL返回金额是字符串且是单价, 需要转成和/cart.js一致的分为单位
   final_line_price: parseFloat(merchandise.price.amount) * 100 * node.quantity,
   original_price: merchandise.compareAtPrice ? parseFloat(merchandise.compareAtPrice.amount) * 100 : null,
   discounts: [] // GraphQL没返回折扣，按需要填充
 };
 
});


  console.log('成功进入渲染01',items);



  const cartContainer = document.querySelector('.Cart__ItemList_con');



  if (!cartContainer) return;



  cartContainer.innerHTML = ''; // 清空旧内容






  console.log('渲染items',items,productIdNumMapLines);
  if (items.length === 0) {
    console.log('商品列表为空，刷新页面');
    // location.reload();
  }
  document.dispatchEvent(new Event("cartGiftReady"));

  items.forEach((item, index) => {
    
    const amountPerQuantity = item.amountPerQuantity;

    const customGiftValue = item.customGiftValue;

    const customShippingValue =  item.customShippingValue;

    const customCartProductGiftValue = item.customCartProductGiftValue;

    const longqiCouponRuleDiscountType  = item.longqiCouponRuleDiscountType;

    const longqiCouponRuleDiscount  = item.longqiCouponRuleDiscount;
    
    const attributesgiftvalue = item.attributesgiftvalue; 

    const discount_product_totalAmount =  item.discount_product_totalAmount;

    const discount_all_totalAmount =  item.discount_all_totalAmount;

    const variantId = item.variant_id;



    const productId = item.product_id;



    const skuWord = item.sku || '';



    const image = item.image || '';



    const productUrl = item.url || '#';



    const title = item.product_title || item.title;



    const variantTitle = item.variant_title || '';



    const quantity = item.quantity;



    const line = index + 1;



    const linePrice = (item.final_line_price / 100).toFixed(2);



    const originalPrice = item.original_price ? (item.original_price / 100).toFixed(2) : '';







    // 折扣显示



    const discountAllocations = item.discounts || item.discount_allocations || [];



    const discountHtml = discountAllocations.map(discount => {



      const amount = (discount.amount / 100).toFixed(2);



      return `<li class="CartItem__Discount">${discount.title || ''}: -<span class="money">$${amount}</span></li>`;



    }).join('');







    // === 使用你的原始 HTML 结构渲染 ===

    // 判断 title 是否包含 Free Gifts

    const giftWordHtml = title.includes('Free Gifts')

      ? `<div class="gift-word">free Gifts</div>`

      : '';

      if (isNaN(discount_product_totalAmount)) {
        discount_product_totalAmount = amountPerQuantity;
      }

    // 判断当前产品是否为赠品或者运费产品
    // if (attributesgiftvalue) {
    //   const giftNone = 'display:none;'
    //   console.log("打印赠品值",giftNone);
    // }
    // console.log("打印赠品值2",giftNone);
    console.log('customGiftValue',customGiftValue);
    console.log('customGiftValue',customShippingValue);
    // console.log('customProductGift',customCartProductGiftValue)


    let giftNone = ''; // 先在外面声明，初始值为空
    // if (attributesgiftvalue) {
    //   giftNone = 'display:none;';
    //   console.log("打印赠品值", giftNone);
    // }
    if (customGiftValue === true || 
        customShippingValue === true ) {
        giftNone = 'display:none;';
        console.log("打印赠品值", giftNone);
    }
    let discountCodeNone = ''
    // if (longqiCouponRuleDiscountType == undefined ) {
    //   discountCodeNone = 'display:none;';
    // }

    let discountAllTotalAmountRounded = 0; // 初始化为数字 0
    if (discount_all_totalAmount != null) { // 避免 undefined 或 null
        // 四舍五入到小数点后两位
        discountAllTotalAmountRounded = Math.round(discount_all_totalAmount * 100) / 100;
        console.log('四舍五入保留两位小数:', discountAllTotalAmountRounded);
    }
    // 转为数字进行判断
    const discountAllTotalAmountRoundedNum = Number(discountAllTotalAmountRounded);
    if (discountAllTotalAmountRoundedNum <= 0) {
        discountCodeNone = 'display:none;';
    } else {
        discountCodeNone = ''; // 正常显示（保持为空）
    }



    // 判断当前产品id 是否符合条件
    // console.log('productIdNumMapLine1176判断产品id',productIdNumMapLine);   product-id-json=${}
    
    console.log("1175循环里用到的 productIdNumMapLines:", productIdNumMapLines,productId);
    const product_id_best = productId.split('/').pop();
    // console.log("1177循环里用到的 productIdNumMapLines:", productIdNumMapLines,product_id);

    let productNoneA = 'display:none;';
    let productNoneB = 'display:none;';
    let productNoneC = 'display:none;';
    let productNoneD = 'display:none;';

    // 假设当前循环中的商品数字 id
      console.log("最终 productNone:", product_id_best);
    let discountOrPriceA = '';
    let discountOrPriceB = '';
    if (productIdNumMapLines[product_id_best]) {
    // 判断到best合集的产品
    // longqiCouponRuleDiscountType
    // longqiCouponRuleDiscount
    //原价：originalPrice
    //现价：amountPerQuantity
    //一口价：discount_product_totalAmount
    //折扣比例：discountOrPriceA = (原价-现价)/原价
    //折扣金额：discountOrPriceB = 原价-现价
    
    // discountOrPriceA = Math.round(((originalPrice - amountPerQuantity) / originalPrice) * 10000) / 100;
    // discountOrPriceB = Math.round((originalPrice - amountPerQuantity) * 100) / 100;

      
      

    // console.log('原价：',originalPrice,'现价：',discount_product_totalAmount);
    
    // 再判断元字段是否为空
      if (longqiCouponRuleDiscountType == '1') {
        
        productNoneA = ''; // 覆盖掉 
        discountOrPriceA = Math.round(((originalPrice - amountPerQuantity) / originalPrice) * 10000) / 100;
        console.log("最终 productNone:",1);
        
      }else if(longqiCouponRuleDiscountType == '2'){
        productNoneB = ''; // 覆盖掉 
        discountOrPriceB = Math.round((originalPrice - amountPerQuantity) * 100) / 100;
        console.log("最终 productNone:",2);
        

      }else if(longqiCouponRuleDiscountType  == null){
        productNoneC = ''; // 覆盖掉 
        discountOrPriceB = Math.round((originalPrice - amountPerQuantity) * 100) / 100;
        console.log("最终 productNone:",3);
      }
      console.log('最终 productNone原价：',originalPrice,'现价：',amountPerQuantity,'一口价',discount_product_totalAmount,'折扣比例',discountOrPriceA,'折扣金额',discountOrPriceB);
      




      productNoneD = '';

    }
    console.log("最终 productNone:",longqiCouponRuleDiscountType,'a', productNoneA,'b',productNoneB,'c',productNoneC);

    const itemHtml = `



    <div class="89 CartItem ${title.includes('Free Gifts')? 'free-gift' : ''}"   sku-id="${variantId}"  product-id="${productId}" sku-word="${skuWord}">



      <div class="CartItem__ImageWrapper AspectRatio">



        <div class="CartItem__ImageWrapper_pic" style="--aspect-ratio: 1.0">



            <img class="CartItem__Image" src="${image}" alt="${title}">



            ${discountAllocations.length ? `<span class="discount">${discountAllocations[0].title || ''}</span>` : ''}

        </div>

      </div>







      <div class="CartItem__Info">



        <!-- 删除按钮 -->



        <a href="/cart/change?quantity=0&line=${line}" style="${giftNone}" class="CartItem__Remove Link Link--underlineShort iconfont icon-close" data-quantity="0" data-line="${line}" data-action="remove-item"></a>







        <h2 class="CartItem__Title Heading">



          <a href="${productUrl}">${title}</a>



        </h2>







        <div class="CartItem__Meta Heading Text--subdued">



          <p class="CartItem__Variant">${variantTitle}</p>



          ${giftWordHtml}



          ${discountHtml ? `<ul class="CartItem__DiscountList">${discountHtml}</ul>` : ''}



        </div>







        <!-- 移动端数量+价格 -->



        <div class="quantity_price_m clearFix">



          <div class="CartItem__LinePriceList Heading Text--subdued">



            <div class="CartItem__PriceList" style="${giftNone}">



              <span class="CartItem__Price Price Price--highlight"><span class="money">$${discount_product_totalAmount}</span></span>



              ${originalPrice ? `<span class="CartItem__OriginalPrice Price Price--compareAt"><span class="money">$${originalPrice}</span></span>` : ''}



            </div>
            <ul class="CartItem__DiscountList" style="${giftNone}">
              <li class="CartItem__Discount" style="${discountCodeNone}">
                  <svg class="Icon Icon--coupon " role="presentation" viewBox="0 0 15 14" fill="none">
                       <path d="M4.92132 5.29613C5.40457 5.29613 5.79632 4.90438 5.79632 4.42113C5.79632 3.93789 5.40457 3.54613 4.92132 3.54613C4.43807 3.54613 4.04632 3.93789 4.04632 4.42113C4.04632 4.90438 4.43807 5.29613 4.92132 5.29613Z" fill="#1B1811"></path>
                       <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00966 1.1778H6.96299L3.46299 1.42863C2.64781 1.50158 2.00176 2.14763 1.92882 2.9628L1.67216 6.4628C1.63993 6.78485 1.75084 7.1048 1.97549 7.3378L6.89882 12.2611C7.10677 12.4614 7.38599 12.5706 7.67466 12.5645C8.1163 12.5606 8.5374 12.3774 8.84132 12.057L12.5572 8.34697C13.1344 7.86844 13.2249 7.01705 12.7613 6.4278L7.80882 1.46947C7.59983 1.27079 7.32132 1.1619 7.03299 1.16613L7.00966 1.1778ZM7.03299 2.11697C7.06716 2.10622 7.10382 2.10622 7.13799 2.11697L12.0672 7.04613C12.1148 7.26476 12.0332 7.4914 11.8572 7.62947L8.12966 11.357C8.00686 11.4902 7.83787 11.5715 7.65716 11.5845H7.55799L2.64632 6.63197C2.63063 6.59063 2.63063 6.54497 2.64632 6.50363L2.90299 3.00363C2.94878 2.68619 3.19364 2.43427 3.50966 2.37947L7.00966 2.12863L7.03299 2.11697Z" fill="#1B1811"></path>
                  </svg><span class="line-code"></span>: -<span class="money">$${discountAllTotalAmountRounded} </span>
                </li>
            </ul>



          </div>

          <div class="CartItem__Actions Heading Text--subdued" style="text-align: center">



            <div class="CartItem__QuantitySelector 1" style="${giftNone}">



              <div class="QuantitySelector">



                <a class="QuantitySelector__Button Link Link--primary minus_cart_num" href="/cart/change?quantity=${quantity - 1}&line=${line}" data-quantity="${quantity - 1}" data-line="${line}" data-action="update-item-quantity">



                  <svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2"><path d="M1,1 L15,1" stroke="currentColor" fill="none" stroke-linecap="square"></path></svg>



                </a>



                <input type="text" name="updates[]" class="QuantitySelector__CurrentQuantity" data-line="${line}" value="${quantity}">



                <a class="QuantitySelector__Button Link Link--primary plus_cart_num" href="/cart/change?quantity=${quantity + 1}&line=${line}" data-quantity="${quantity + 1}" data-line="${line}" data-action="update-item-quantity">



                  <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16"><g stroke="currentColor" fill="none" stroke-linecap="square"><path d="M8,1 L8,15"></path><path d="M1,8 L15,8"></path></g></svg>



                </a>



              </div>



            </div>



          </div>



        </div>



      </div>







      <!-- PC端数量价格 -->

      <div class="CartItem__Actions Heading Text--subdued" style="text-align: center">



        <div class="CartItem__QuantitySelector 2" style="${giftNone}">



          <div class="QuantitySelector">



            <a class="QuantitySelector__Button Link Link--primary minus_cart_num" href="/cart/change?quantity=${quantity - 1}&line=${line}" data-quantity="${quantity - 1}" data-line="${line}" data-action="update-item-quantity">



              <svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2"><path d="M1,1 L15,1" stroke="currentColor" fill="none" stroke-linecap="square"></path></svg>



            </a>



            <input type="text" name="updates[]" class="QuantitySelector__CurrentQuantity" data-line="${line}" value="${quantity}">



            <a class="QuantitySelector__Button Link Link--primary plus_cart_num" href="/cart/change?quantity=${quantity + 1}&line=${line}" data-quantity="${quantity + 1}" data-line="${line}" data-action="update-item-quantity">



              <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16"><g stroke="currentColor" fill="none" stroke-linecap="square"><path d="M8,1 L8,15"></path><path d="M1,8 L15,8"></path></g></svg>



            </a>



          </div>



        </div>



      </div>

      <div class="CartItem__LinePriceList Heading Text--subdued quantity_pc" style="text-align: right">



        <div class="CartItem__PriceList" style="${giftNone}">



          <span class="CartItem__Price Price Price--highlight"><span class="money">$${discount_product_totalAmount}</span></span>



          ${originalPrice ? `<span class="CartItem__OriginalPrice Price Price--compareAt"><span class="money">$${originalPrice}</span></span>` : ''}



        </div>
        <ul class="CartItem__DiscountList" style="${giftNone}">
              <li class="CartItem__Discount" style="${discountCodeNone}">
                  <svg class="Icon Icon--coupon " role="presentation" viewBox="0 0 15 14" fill="none">
                       <path d="M4.92132 5.29613C5.40457 5.29613 5.79632 4.90438 5.79632 4.42113C5.79632 3.93789 5.40457 3.54613 4.92132 3.54613C4.43807 3.54613 4.04632 3.93789 4.04632 4.42113C4.04632 4.90438 4.43807 5.29613 4.92132 5.29613Z" fill="#1B1811"></path>
                       <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00966 1.1778H6.96299L3.46299 1.42863C2.64781 1.50158 2.00176 2.14763 1.92882 2.9628L1.67216 6.4628C1.63993 6.78485 1.75084 7.1048 1.97549 7.3378L6.89882 12.2611C7.10677 12.4614 7.38599 12.5706 7.67466 12.5645C8.1163 12.5606 8.5374 12.3774 8.84132 12.057L12.5572 8.34697C13.1344 7.86844 13.2249 7.01705 12.7613 6.4278L7.80882 1.46947C7.59983 1.27079 7.32132 1.1619 7.03299 1.16613L7.00966 1.1778ZM7.03299 2.11697C7.06716 2.10622 7.10382 2.10622 7.13799 2.11697L12.0672 7.04613C12.1148 7.26476 12.0332 7.4914 11.8572 7.62947L8.12966 11.357C8.00686 11.4902 7.83787 11.5715 7.65716 11.5845H7.55799L2.64632 6.63197C2.63063 6.59063 2.63063 6.54497 2.64632 6.50363L2.90299 3.00363C2.94878 2.68619 3.19364 2.43427 3.50966 2.37947L7.00966 2.12863L7.03299 2.11697Z" fill="#1B1811"></path>
                  </svg><span class="line-code"></span>: -<span class="money">$${discountAllTotalAmountRounded} </span>
                </li>
            </ul>



      </div>



    </div>`;







    cartContainer.insertAdjacentHTML('beforeend', itemHtml);



  });



}



//添加赠品

async function addGiftToCart(cartGid, addGift) {

  const lines = addGift.map(variantGid => `

  {

    merchandiseId: "${variantGid}",

    quantity: 1,

    attributes: [

      { key: "is_gift", value: "true" }

    ]

  }

`).join(',');



  const mutation = `

mutation {

  cartLinesAdd(

    cartId: "${cartGid}",

    lines: [${lines}]

  ) {

    userErrors { message }

    cart {

      id
      discountCodes{
            applicable
            code  
        }
      lines(first: 50) {

        edges {

          node {

            id

            quantity

            attributes { key value }
        cost {
                totalAmount {
                  amount
                  currencyCode
                }
                amountPerQuantity {
                  amount
                  currencyCode
                }
                subtotalAmount {
                  amount
                  currencyCode
                }
          }
          discountAllocations{
            discountedAmount{
                amount  
            }
          }

            merchandise {

              ... on ProductVariant {

                id

                title

                sku

                price { amount currencyCode }

                compareAtPrice { amount currencyCode }

                image { url altText }

                product {

                  id

                  title

                  handle

                  productType

                  featuredImage { url altText }

                coupon_rule: metafield(namespace: "longqi", key: "coupon_rule") {
                  value
                  type
                }
                gift: metafield(namespace: "custom", key: "gift") {
                  value
                  type
                }
                shipping: metafield(namespace: "custom", key: "shipping") {
                  value
                  type
                }
                cart_product_gift: metafield(namespace: "custom", key: "cart_product_gift") {
                  value
                  type
                }
                  tags

                }

              }

            }

          }

        }

      }

      cost {

        subtotalAmount { amount currencyCode }

        totalAmount { amount currencyCode }

      }

    }

  }

}

`;



  var carts =  graphqlStar(mutation);

  console.log('add carts',carts)

  return carts;

}



//取消赠品

async function removeGiftFromCart(lineId,cartGid) {

  if(!lineId) {

    return false;

  }

  const mutation = `

    mutation {

  cartLinesRemove(

    cartId: "${cartGid}",

      lineIds: [${lineId.map(id => `"${id}"`).join(',')}]

  ) {

    userErrors { message }

    cart {

      id
      discountCodes{
            applicable
            code  
        }
      lines(first: 10) {

        edges {

          node {

            id

            quantity

             cost {
            totalAmount {
              amount
              currencyCode
            }
            amountPerQuantity {
              amount
              currencyCode
            }
            subtotalAmount {
              amount
              currencyCode
            }
          }
          discountAllocations{
            discountedAmount{
                amount  
            }
          }

            merchandise {

              ... on ProductVariant {

                id

                title

                sku

                price {

                  amount

                  currencyCode

                }

                compareAtPrice {

                  amount

                  currencyCode

                }

                image {

                  url

                  altText

                }

                product {

                  id

                  title

                  handle

                  productType

                  featuredImage {

                    url

                    altText

                  }
                  
                coupon_rule: metafield(namespace: "longqi", key: "coupon_rule") {
                  value
                  type
                }
                gift: metafield(namespace: "custom", key: "gift") {
                  value
                  type
                }
                shipping: metafield(namespace: "custom", key: "shipping") {
                  value
                  type
                }
                cart_product_gift: metafield(namespace: "custom", key: "cart_product_gift") {
                  value
                  type
                }
                  tags

                }

              }

            }

            attributes {

              key

              value

            }

          }

        }

      }

      cost {

        subtotalAmount { amount currencyCode }

        totalAmount { amount currencyCode }

      }

    }

  }

}

  `;



  var carts =  graphqlStar(mutation);

  console.log('del carts',carts)

  return carts;

}









//查询购物车行数据

async function getCartLines(cartGid){

  const query = `query {

  cart(id: "${cartGid}") {

    id

    cost {

      subtotalAmount {

        amount

        currencyCode

      }

      totalAmount {

        amount

        currencyCode

      }

    }
      discountCodes{
            applicable
            code  
        }

    lines(first: 50) {

      edges {

        node {

          id

          quantity

          attributes {

            key

            value

          }

           cost {
            totalAmount {
              amount
              currencyCode
            }
            amountPerQuantity {
              amount
              currencyCode
            }
            subtotalAmount {
              amount
              currencyCode
            }
          }

          discountAllocations{
            discountedAmount{
                amount  
            }
          }

          merchandise {

            ... on ProductVariant {

              id

              title

              image {

                url

                altText

              }

              product {

                id

                title

                featuredImage {

                  url

                  altText

                }
                
                coupon_rule: metafield(namespace: "longqi", key: "coupon_rule") {
                  value
                  type
                }
                gift: metafield(namespace: "custom", key: "gift") {
                  value
                  type
                }
                shipping: metafield(namespace: "custom", key: "shipping") {
                  value
                  type
                }
                cart_product_gift: metafield(namespace: "custom", key: "cart_product_gift") {
                  value
                  type
                }
              }

            }

          }

        }

      }

    }

    }

  }`;

  console.log('lastcar', graphqlStar(query));  //当前购物车数据



  return  graphqlStar(query);

}

